// Lib
import { connect } from 'react-redux';

// Constants
import { MeasurementsStoreContext } from './MeasurementsProvider';

export default (...args) => {
    const opts = {
        ...args[3],
        context: MeasurementsStoreContext,
        getDisplayName: (component) => `MeasurementsConnect(${component})`,
    };
    return connect(args[0], args[1], args[2], opts);
};
